import React, { type HTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { Tag } from '@/components/base/Tag'
import { rewardTagVariants, rewardTagButtonVariants } from './RewardTag.variants'
import type { Cta } from './types'

export interface RewardTagProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  reward: string
  icon: React.ReactNode
  cta?: Cta
  accentColor?: 'none' | 'yellow' | 'green' | 'blue' | 'pink'
}

export const RewardTag = forwardRef<HTMLDivElement, RewardTagProps>(
  ({ label, reward, icon, cta, accentColor = 'none', className, ...props }, ref) => {
    return (
      <div className={rewardTagVariants({ accentColor, className })} ref={ref} {...props}>
        <div
          className={twMerge(
            'flex items-center justify-center',
            'p-1 gap-2',
            '[text-shadow:0px_1px_1px_rgba(0,0,0,0.25)]'
          )}
        >
          <Tag accentColor={accentColor} className="py-0 h-[23px]">
            {icon}
            <span className="leading-none">{reward}</span>
          </Tag>

          <span className="text-md font-bold leading-none">{label}</span>
        </div>

        {cta ? (
          <button
            className={twMerge(rewardTagButtonVariants({ accentColor }), cta.className)}
            onClick={cta.onClick}
            type="button"
          >
            {cta.icon || cta.label}
          </button>
        ) : null}
      </div>
    )
  }
)

RewardTag.displayName = 'RewardTag'
